import { object, type InferType } from 'yup';

import {
  queryColumn,
  queryNumberPositive,
  queryNumberPositiveArray,
  queryOperator,
  queryOrder,
  queryPage,
  queryString,
} from '@/ui/Table/query/schema';
import {
  searchFormDateOperatorValues,
  searchFormInOperatorValues,
  searchFormStringLikeOperatorValues,
  searchFormNumberOperatorValues,
} from '@/ui/Search/operators';
import type { FileFragmentFragment } from '@/graphql/generated/graphql';

export const FILE_TABLE_SORT_COLUMNS = [
  'id',
  'uri',
  'name',
  'original_name',
  'mime_type',
  'ext',
  'path',
  'size',
  'creation_time',
  'last_update_time',
  'created_by',
  'last_update_by',
] as const satisfies readonly (keyof FileFragmentFragment)[];

export type FileTableSortColumn = (typeof FILE_TABLE_SORT_COLUMNS)[number];

export const filesTableSearchSchema = object({
  id: queryNumberPositiveArray,
  idOperator: queryOperator('id', searchFormInOperatorValues),
  name: queryString,
  nameOperator: queryOperator('name', searchFormStringLikeOperatorValues),
  originalName: queryString,
  originalNameOperator: queryOperator('originalName', searchFormStringLikeOperatorValues),
  mimeType: queryString,
  mimeTypeOperator: queryOperator('mimeType', searchFormStringLikeOperatorValues),
  ext: queryString,
  extOperator: queryOperator('ext', searchFormStringLikeOperatorValues),
  path: queryString,
  pathOperator: queryOperator('path', searchFormStringLikeOperatorValues),
  uri: queryString,
  uriOperator: queryOperator('uri', searchFormStringLikeOperatorValues),
  size: queryNumberPositive,
  sizeOperator: queryOperator('size', searchFormNumberOperatorValues),
  creationTime: queryString,
  creationTimeOperator: queryOperator('creationTime', searchFormDateOperatorValues),
  lastUpdateTime: queryString,
  lastUpdateTimeOperator: queryOperator('lastUpdateTime', searchFormDateOperatorValues),
  createdBy: queryNumberPositiveArray,
  createdByOperator: queryOperator('createdBy', searchFormInOperatorValues),
  lastUpdateBy: queryNumberPositiveArray,
  lastUpdateByOperator: queryOperator('lastUpdateBy', searchFormInOperatorValues),
  lastUpdateByType: queryString,
  lastUpdateByTypeOperator: queryOperator('lastUpdateByType', searchFormStringLikeOperatorValues),
  lastUpdateReason: queryString,
  lastUpdateReasonOperator: queryOperator('lastUpdateReason', searchFormStringLikeOperatorValues),
  page: queryPage,
  first: queryNumberPositive,
  column: queryColumn<FileTableSortColumn>([...FILE_TABLE_SORT_COLUMNS]),
  order: queryOrder,
});

export type FormValues = InferType<typeof filesTableSearchSchema>;
